import { createSelector } from 'reselect';

const getProperties = state => state.properties;

const PropertiesSelectors = {
    makeNumTotalListings: createSelector([getProperties], properties => properties.numTotalListings),
    makePager: createSelector([getProperties], properties => properties.pager),
    makeProperties: createSelector([getProperties], properties => properties.properties),
    makeMaintenancePartner: createSelector([getProperties], properties => properties.properties.maintenancePartner),
    makeCurrentProperty: createSelector([getProperties], properties => properties.currentProperty),
    makePropertiesFilters: createSelector([getProperties], properties => properties.propertiesFilters),
    makePropertyConversion: createSelector([getProperties], properties => properties.propertyConversion),
    makeFeedClaimAndConvertUpdate: createSelector([getProperties],
        properties => properties.properties.feedClaimAndConvertUpdate),
};

export default PropertiesSelectors;
